import { render } from "./TheCheckboxConfirmDialog.vue?vue&type=template&id=6d56e65e"
import script from "./TheCheckboxConfirmDialog.vue?vue&type=script&lang=js"
export * from "./TheCheckboxConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__